class PhotoAlbumModel extends App.Models.BaseModel {
    modelUrl = 'PhotoAlbum';

    fetchWithCriteria = (obj) => {
        return Monet.Model.fetchWithCriteria({
            options: obj,
            model: this
        });
    }
}

App.Models.PhotoAlbum = PhotoAlbumModel;
